import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

type updateChapterSettingsType = {
  chapter_id: number;
  // 'hide_moves' is only ever read back for chapters saved before
  // `conceal_moves` existed as an independent toggle - new writes should use
  // `conceal_moves` instead of this value.
  chapter_mode?: 'analysis' | 'lesson' | 'practice' | 'hide_moves';
  conceal_moves?: boolean;
  orientation?: 'W' | 'B';
  name?: string;
  description?: string;
  practice_goal?: {type: string; value?: number} | null;
};

export default function useUpdateChapterSettings() {
  return useMutation(async (payload: updateChapterSettingsType) => {
    const response = await ChessRestClient.post(
      `learning/study_chapter/update_settings/`,
      payload,
    );
    return response.data;
  });
}
